<div class="dialogue-content">
    <mat-dialog-content>
      <div class="text-center">
        <form novalidate>
          <img src="../../../assets/images/check-right.svg" class="mb-4 m-auto d-table" />
          <div class="mat-dialogue-header">
            <p class="mat-dialog-title" style="color: aliceblue">
              {{ data.message }}
            </p>
          </div>
          <button matButton="filled" type="button" class="btn dialog-btn-primary mt-4" (click)="close()">Done</button>
        </form>
      </div>
    </mat-dialog-content>
  </div>
  